import { useStripe } from '@stripe/react-stripe-js';
import { PaymentRequest, PaymentRequestPaymentMethodEvent } from '@stripe/stripe-js';
import { useEffect, useState } from 'react';
import { Discount } from '../../../../models/UserPayment';
import { PlanDataExtracted } from '../../../../types/plan';
import { calculateAmountWithDiscount } from '../../../../utils/price/price.utils';

interface UsePaymentRequestProps {
  currentPlan: PlanDataExtracted;
  discount: Discount | null;
  paymentAction: (event: PaymentRequestPaymentMethodEvent) => Promise<void>;
}

export const usePaymentRequest = ({ currentPlan, discount, paymentAction }: UsePaymentRequestProps) => {
  const stripe = useStripe();

  const [paymentRequest, setPaymentRequest] = useState<PaymentRequest | null>(null);

  useEffect(() => {
    if (stripe && currentPlan.sanitizedAmount !== 0) {
      const amount = calculateAmountWithDiscount(currentPlan.sanitizedAmount, discount);
      const pr = stripe.paymentRequest({
        country: 'US',
        currency: 'usd',
        total: {
          label: currentPlan.sanitizedPlanTitle,
          amount,
        },
      });
      pr.canMakePayment().then((result) => {
        if (result) {
          setPaymentRequest(pr);
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stripe]);

  useEffect(() => {
    if (paymentRequest) {
      // hack!
      // paymentRequest interface does not expose "hasRegisteredListener"
      // but in fact it is accessible...
      if ((paymentRequest as any).hasRegisteredListener('paymentmethod')) {
        paymentRequest.off('paymentmethod');
      }
      paymentRequest.on('paymentmethod', (event) => {
        paymentAction(event);
      });
    }
  }, [paymentRequest, discount, paymentAction]);

  useEffect(() => {
    if (paymentRequest) {
      const amount = calculateAmountWithDiscount(currentPlan.sanitizedAmount, discount);

      paymentRequest.update({
        total: {
          label: currentPlan.sanitizedPlanTitle,
          amount,
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentRequest, discount]);

  return { paymentRequest };
};
